import React, { Component } from 'react';
import gutter from '../../config/vars';

class QuickLinks extends Component {
  render() {
    if (Array.isArray(this.props.config.field_links_1)) {
      return this.props.config.field_links_1.map((item, i) =>
        <li className="noBullets" key={i} style={{
          listStyle:"none",
          display:"inline",
          margin:0,
        }}><a className="greyUOrangeU" style={{
          padding: "16px " + gutter,
          fontFamily: "Oswald, sans-serif",
          fontSize:"16px",
          border: "none",
          display: "block",
          letterSpacing: ".09px",
          borderBottom:"1px solid #cecece",
          backgroundColor: "rgb(235, 235, 235)",
          textTransform: "uppercase",
        }} href={item.url}>{item.title}</a></li>
      );
    } else {
      return (
        <li className="noBullets" style={{
          listStyle:"none",
          display:"inline",
          margin:0,
        }}><a className="greyUOrangeU" style={{
          padding: "16px " + gutter,
          fontFamily: "Oswald, sans-serif",
          fontSize:"16px",
          border: "none",
          display: "block",
          letterSpacing: ".09px",
          borderBottom:"1px solid #cecece",
          backgroundColor: "rgb(235, 235, 235)",
          textTransform: "uppercase",
        }} href={this.props.config.field_links_1.url}>{this.props.config.field_links_1.title}</a></li>
      )
    }
  }
}

export default QuickLinks;
